const theme = {
  colors: {
    primary: '#FF6B6B',
    secondary: '#D77A61',
    accent: '#4ECDC4',
    dark: '#223843',
    grey: '#9DA0A3',
    light: '#EFF1F3',
    white: '#FFF',
    black: '#1C1F23',
    blackLg: '#292F36'
  },
  fonts: {
    weight: {
      regular: 400,
      bold: 700
    }
  },
  mediaQueries: {
    land: `only screen and (min-width: 30em)`,
    desktop: `only screen and (min-width: 56.25em)`,
  
   },
};

export default theme;
